import {useContext} from 'react'

import { CreateGrupoModalFormWrapper } from './CreateGrupoModalFormWrapper'
import { CreateGrupoModalHeader } from './CreateGrupoModalHeader'
import { PartnerContext } from '../PartnerContexts'

const CreateGrupoModal = () => {

  const {openShowModal} = useContext(PartnerContext)

  return (
    <>
      {openShowModal && (
        <>
          <div>
            <div className='modal fade show d-block' role='dialog' tabIndex={-1} aria-modal='true'>
              {/* begin::Modal dialog */}
              <div className='modal-dialog modal-dialog-centered modal-xl'>
                {/* begin::Modal content */}
                <div className='modal-content'>
                  <CreateGrupoModalHeader />
                  {/* begin::Modal body */}
                  <div className='modal-body scroll-y mx-5 mx-xl-5 my-2'>
                    <CreateGrupoModalFormWrapper />
                  </div>
                  {/* end::Modal body */}
                </div>
                {/* end::Modal content */}
              </div>
              {/* end::Modal dialog */}
            </div>
          </div>
          {/* begin::Modal Backdrop */}
          <div className='modal-backdrop fade show'></div>
          {/* end::Modal Backdrop */}
        </>
      )}
    </>
  )
}

export {CreateGrupoModal}
